export default "__VITE_ASSET__x1TQg6TP__"